import Grid from "@mui/material/Grid";

import {
  CmpTypographyField,
  CmpRadioButton,
  CmpSelectField,
} from "../../../Component/Common/ToolBox/ToolBox.js";

export default function WmsContent({
  DetailReportRadioBtn,
  selectedOption,
  sBufferObj,
  xtitle = "",
  fStamped,
  fStampedDetail,
  sWebStampedReportArr,
  sWebStampedDetailReportArr,
  //View
}) {
  return (
    <form className="" id="PendingDoDetailReportContent">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <CmpTypographyField
            xcomponent={"h1"}
            xText={xtitle}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="PENDING_FOR_DELIVERY"
                label="Pending For Delivery"
                checked={selectedOption === "PENDING_FOR_DELIVERY"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="PENDING_FOR_DELIVERY_DETAIL"
                label="Pending For Delivery - Detail"
                checked={selectedOption === "PENDING_FOR_DELIVERY_DETAIL"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="STAMP_PENDING"
                label="Stamped"
                checked={selectedOption === "STAMP_PENDING"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="STAMP_DTL_PENDING"
                label="Stamped Detail"
                checked={selectedOption === "STAMP_DTL_PENDING"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={
                selectedOption === "STAMP_PENDING"
                  ? ""
                  : "hide-radio-buttonStockReport"
              }
            >
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 0, md: 0 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
              >
                <Grid item xs={12} sm={4} md={4}>
                  <CmpTypographyField xcomponent={"span"} xText={"Stamped"} />
                </Grid>
                <Grid item xs={6} sm={4} md={4}>
                  <CmpSelectField
                    xLabelText="sStamped"
                    xValue={sBufferObj.sStamped}
                    xOnChange={fStamped}
                    xName={"sStamped"}
                    xData={sWebStampedReportArr}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={false}
                    xErrorMessage={""}
                    xDisable={false}
                    // xOnKeyUp={xKeyIInboundGrn}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={
                selectedOption === "STAMP_DTL_PENDING"
                  ? ""
                  : "hide-radio-buttonStockReport"
              }
            >
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 0, md: 1 }}
                columnSpacing={{ xs: 0, sm: 0, md: 0 }}
                columns={{ xs: 12, sm: 12, md: 12 }}
                alignItems="center"
              >
                <Grid item xs={12} sm={4} md={4}>
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"Stamped Detail"}
                  />
                </Grid>
                <Grid item xs={6} sm={4} md={4}>
                  <CmpSelectField
                    xLabelText="sStamped"
                    xValue={sBufferObj.sStampedDetail}
                    xOnChange={fStampedDetail}
                    xName={"sStampedDetail"}
                    xData={sWebStampedDetailReportArr}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={false}
                    xErrorMessage={""}
                    xDisable={false}
                    // xOnKeyUp={xKeyIInboundGrn}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
